import { call, put } from 'redux-saga/effects';
import { appDataService } from '@flow/appsync-client';
import gql from 'graphql-tag';
import { removeFavourite } from '@flow/graphql/mutations';
import { REMOVE_FAVOURITE_ERROR, REMOVE_FAVOURITE_SUCCESS } from '@flow/store/user/constants';

const ApiRequest = (programId: string) => {
  return appDataService.client.mutate({
    mutation: gql(removeFavourite),
    variables: { id: programId }
  });
};

export function * removeFavouriteFlow(programId: string, onComplete?: (result: APICallResult) => any) {
  try {
    const response = yield call(ApiRequest, programId);

    if (response) {
      yield put({ type: REMOVE_FAVOURITE_SUCCESS, data: response.data });

      if (onComplete) {
        onComplete({ data: response.data });
      }
    }
  } catch (error) {
    yield put({ type: REMOVE_FAVOURITE_ERROR });

    if (onComplete) {
      onComplete({ error });
    }
  }
  return true;
}


// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/store/user/flows/remove-favourite-flow.ts